module.exports = "/images/region-area.svg?e5de697167d3c7f7f8c349ca74f5982a";